import { GridDirection } from "../interaction_picker/navigateGroupedGrid";

/**
 * Arrow-key movement over the asset grid, where the first cell can be the
 * upload drop zone: assets occupy cells `offset`..`offset + count - 1`, and
 * the highlight indexes ASSETS, never the drop zone.
 *
 * Horizontal movement walks the flat asset order. Vertical movement is
 * column-preserving on the CELL geometry (which is what the eye sees), with
 * moves that would land on the drop zone or off the edges clamped to the
 * nearest asset.
 */
export function navigateAssetGrid(
  count: number,
  columns: number,
  offset: number,
  index: number,
  direction: GridDirection
): number {
  if (count === 0) return 0;
  const lastIndex = count - 1;

  if (direction === "left") return Math.max(index - 1, 0);
  if (direction === "right") return Math.min(index + 1, lastIndex);

  const cell = index + offset;

  if (direction === "down") {
    const target = cell + columns - offset;
    return Math.min(target, lastIndex);
  }

  // up
  const target = cell - columns - offset;
  return Math.max(target, 0);
}
